import React from 'react'
import styled, { css } from 'styled-components'
import { buttonUnstyledStyles } from 'components/Button'
import { ReactComponent as PlusIcon } from 'icons/plus-16.svg'

const AddTextWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;

    display: inline-flex;
    align-items: center;

    padding: 0 12px;

    color: ${theme.colors.foreground.secondary[4]};
    font-size: ${theme.fontSizes.tiny};
    font-weight: ${theme.fontWeights.semibold};

    user-select: none;
  `
)

const AddButton = styled.button`
  ${buttonUnstyledStyles};

  display: inline-flex;
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};

  margin-left: auto;
  padding: 0;

  transition: color
    ${({ theme }) =>
      `${theme.transitions.duration[0]} ${theme.transitions.timing.easeInOut}`};

  :hover {
    color: ${({ theme }) => theme.colors.text.dark.primary};
  }
`

const StyledAddButton = styled(PlusIcon)`
  width: 16px;
  height: 16px;
`

const ProjectsHeaderText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary[4]};
    font-size: ${theme.fontSizes.tiny};
    font-weight: ${theme.fontWeights.semibold};
    text-transform: uppercase;
  `
)

export interface ProjectsHeaderProps {
  /** Use for external styling. */
  className?: string
  /** Handle the onClick event of the AddButton. */
  onAdd?: () => void
}

/**
 * ProjectsHeader
 *
 * This component visually represents the "Projects" text with a (+) button.
 *
 * @example // Basic example
 * <ProjectsHeader onAdd={() => {openModal()}}/>
 */
const ProjectsHeader: React.FC<ProjectsHeaderProps> = ({
  className,
  onAdd,
}) => (
  <AddTextWrapper className={className}>
    <ProjectsHeaderText>Projects</ProjectsHeaderText>
    {onAdd && (
      <AddButton data-testid="add-project" onClick={onAdd}>
        <StyledAddButton aria-label="Add a new project" />
      </AddButton>
    )}
  </AddTextWrapper>
)

export default ProjectsHeader
